import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/app/[locale]/(admin)/dashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContainer","PageHeader","PageIcon","PageTitle","PageContent"] */ "/app/apps/web/src/app/components/page-layout.tsx");
